import { Form, Input, message, Modal } from "antd";
import React, { useState } from "react";
import { RecoilState, useRecoilState } from "recoil";
import { apiAddNewCompany } from "../../../../../api/api";
import { CompanyType } from "../../../../../types";

export const ModalAddNewCompany = ({
  modalState,
  updateDataSource,
}: {
  modalState: RecoilState<boolean>;
  updateDataSource: React.Dispatch<React.SetStateAction<CompanyType[]>>;
}) => {
  const [form] = Form.useForm<any>();
  const [visible, setVisible] = useRecoilState(modalState);
  const [loading, setLoading] = useState<boolean>(false);

  const addNewCompany = async (values: { [index: string]: string }) => {
    setLoading(true);
    const { companyName, login, inn } = values;
    try {
      const resp = await apiAddNewCompany(companyName, login, inn);
      message.success("Организация добавлена");
      updateDataSource((oldArray) => [resp.result, ...oldArray]);
    } finally {
      setLoading(false);
    }
    setVisible(false);
  };

  return (
    <Modal
      title="Добавить"
      visible={visible}
      onOk={() => form.submit()}
      onCancel={() => setVisible(false)}
      confirmLoading={loading}
      afterClose={() => {
        form.resetFields();
      }}
      maskClosable={false}
      width="500px"
      cancelText="Отменить"
      okText="Добавить"
      forceRender
    >
      <Form
        form={form}
        onFinish={addNewCompany}
        labelCol={{
          span: 7,
        }}
      >
        <Form.Item label="Название организации" name="companyName">
          <Input />
        </Form.Item>
        <Form.Item label="Логин" name="login">
          <Input />
        </Form.Item>
        <Form.Item label="ИНН" name="inn">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
